import { useMemo } from "react";

import { findAvailableStep, getStepNumber } from "../../../text/data";

/**
 * Resolves the navigation targets for one intervention step.
 *
 * `activeStep` is owned by InterventionRecord and is the live source of truth
 * while the record is open. It is only absent when a step renders outside that
 * container, so the fallback derives the number from the record's own step list
 * rather than assuming a fixed position.
 *
 * The persisted `interventionAssessmentForm.currentStep` is deliberately not
 * consulted here: overlapping assessment saves can resolve out of order, and an
 * older response echoing a stale step would pull the user back a tab.
 */
export const useStepNavigation = (
  stepName,
  currentInterventionSteps,
  activeStep
) =>
  useMemo(() => {
    const currentStep =
      activeStep ?? getStepNumber(currentInterventionSteps, stepName) ?? 1;

    return {
      currentStep,
      nextStep: findAvailableStep(currentStep, currentInterventionSteps, 1),
      previousStep: findAvailableStep(currentStep, currentInterventionSteps, -1),
      stepNumberOf: (name) => getStepNumber(currentInterventionSteps, name),
    };
  }, [stepName, currentInterventionSteps, activeStep]);
